<template>
	<div class="documents">

		<div v-for="doc in documents" :key="doc.name" class="document">
			<div class="document-icon"><icon :file="doc.icon" :size="48" folder="files-types" /></div>
			<div class="document-content">
				<div class="document-name">
					<span v-if="editing.doc != doc" class="name">
						<span v-if="doc.name">{{ doc.name }}</span>
						<span v-else>{{ doc.url.replace(/.*\//, '') }}</span>
					</span>
					<!-- <input v-if="editing.doc == doc" type="text" class="input" v-model="editing.name" @blur="change_name(doc)" :id="'input-doc-' + doc.id"> -->
				</div>
				<div class="document-description">
					<span title="Type du fichier"><icon file="file" :size="16" /> {{ doc.type }}</span>
					<span title="Ajouté le"><icon file="calendar" :size="16" />{{ doc.date | moment }}</span>
				</div>
			</div>
			<div class="document-actions">
				<!-- <div class="document-action" title="Renommer le fichier" @click="set_editing_doc(doc)"><icon file="edit-2" :size="24" /></div> -->
				<div class="document-action" title="Télécharger le fichier">
					<a :href="doc.url+query_token" target="_blank">
						<icon file="download" :size="24" />
					</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("fr");

export default {
	name: "documents",
	data: function () {
		return {
			editing: {
				doc: false,
				name: ""
			},
		};
	},
	computed: {
		...mapGetters([ "app", "study", "active_study", "user" ]),
		documents () {
			return this.active_study.projet.pieceJointe;
		},
		query_token () {
			return "?token="+this.user.token;
		}
	},
	methods: {
		set_editing_doc: function (doc) {
			this.editing.doc = doc;
			this.editing.name = doc.name;
			this.$nextTick(function () {
				document.querySelector("#input-doc-" + doc.id).focus();
			});
		},
		// change_name: function(doc) {
		// 	this.editing.doc.name = this.editing.name;
		// 	this.editing.doc = false;
		// 	this.editing.name = "";
		// }
	},
	filters: {
		moment: function (value) {
			return moment(value).format("ll");
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'
@import '../../../assets/css/grid'

.documents
	.document
		display block
		min-height (48px + 32px)
		padding 16px 24px
		border-radius radius
		line-height 24px
		white-space nowrap
		cursor default
		&:hover
			background-color #eee
			.document-actions
				opacity 1
		.document-icon
			float left
			transform translateY(1px)
			.icon
				display block
		.document-content
			display block
			margin-left 64px
			.document-name
				display block
				font-weight 500
				transform translateY(1px)
				.input
					display block
					width 180px
					border none
					font inherit
					background transparent
					&:focus
						background #fff
						box-shadow 0 0 0 2px #fff, 0 0 0 4px red
			.document-description
				display block
				transform translateY(-1px)
				color lighten(dark, 50%)
				font-size 12px
				span
					display inline-block
					margin 0 16px 0 0
					> .icon
						float left
						margin 4px 4px 0 0
				a
					text-decoration underline
					&:hover
						text-decoration none
			.document-remove
				opacity 0
				position absolute
				right -4px
				top -4px
				width 24px
				height 24px
				display flex
				align-items center
				justify-content center
				background-color red
				border-radius 100%
				box-shadow 0 0 0 4px #fff
				cursor pointer
				color #fff
				text-align center
				&:hover
					background-color darken(red, 10%)
				&:active
					background-color darken(red, 20%)
					transform translateY(1px)
				.icon
					display block
		.document-actions
			opacity 0
			position absolute
			right 20px
			top 20px
			height 40px
			display flex
			align-items center
			justify-content center
			.document-action
				display inline-block
				width 40px
				height 40px
				padding 8px
				border-radius 100%
				cursor pointer
				color dark
				&:hover
					background-color dark
					color #fff
				.icon
					display block
</style>